import { render, staticRenderFns } from "./AutocompleteSuggestSender.vue?vue&type=template&id=0fe24f44&"
import script from "./AutocompleteSuggestSender.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSuggestSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCombobox,VListItem})
